var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-color"},[_c('el-color-picker',{attrs:{"clearable":false},model:{value:(_vm.valueData),callback:function ($$v) {_vm.valueData=$$v},expression:"valueData"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }